import { jsonProperty, Serializable } from 'ts-serializable';

import { MessageSenderEnum } from '../types/MessageSenderEnum';

export default class MessagesListItemModel extends Serializable {
  @jsonProperty(Number, null) id: number | null = null;
  @jsonProperty(String, null) dateSend: string | null = null;
  @jsonProperty(String, null) senderFio: string | null = null;
  @jsonProperty(String, null) descr: string | null = null;
  @jsonProperty(Number, null) senderType: MessageSenderEnum | null = null;
  @jsonProperty(Boolean, null) isCanDelete: boolean | null = null;
}
